const dialogActions = {
  styleOverrides: {
    root: ({ theme }: { theme: any }) => ({
      padding: theme.spacing(2, 2.5),
      gap: theme.spacing(1),
      borderTop: `${theme.borders.borderWidth[1]} solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.action.hover,
    }),
  },
};

export default dialogActions;
